// libs
import classNames from 'classnames'
import * as React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import { IDateRange } from 'src/interfaces/filters'

// classes
import DatePicker from 'src/components/date/picker/picker'
import InputDate, { IProps as IInputProps } from 'src/components/forms/input_date/input_date'
import InputField from 'src/components/forms/input_field/input_field'
import Popover from 'src/components/popover/popover'

// helpers
import { doesBrowserSupportNativeDateInput, isTouchedDevice } from 'src/utils/browserDetection'
import { readColumnCountFromDOM } from 'src/utils/column_count'
import DateFormatter from 'src/utils/date_formatter/date_formatter'
import './input_date_picker.scss'

const cls: string = CLASS_PREFIX + 'input-date-picker'

interface IProps extends IInputProps {
  onChange?: (value: string) => void;
  leftIcon?: boolean;
  minYear?: number;
  maxYear?: number;
  withoutHeader?: boolean;
}

interface IState {
  supportNativeDatePicker: boolean;
}

export default class InputDatePicker extends React.Component<IProps, IState> {
  constructor (props: IProps) {
    super(props)
    this.state = {
      supportNativeDatePicker: true
    }

    this.handlePickerSelect = this.handlePickerSelect.bind(this)
    this.handleOnChangeDatePicker = this.handleOnChangeDatePicker.bind(this)
  }

  public componentDidMount (): void {
    const supportNativeDatePicker = doesBrowserSupportNativeDateInput()
    this.setState({ supportNativeDatePicker })
  }

  public render () {
    const {
      defaultValue,
      maxYear,
      minYear,
      value,
      onChange,
      className,
      withoutHeader,
      ...props
    } = this.props

    if (isTouchedDevice() && this.state.supportNativeDatePicker && readColumnCountFromDOM() === 1) {
      return (
        <InputField
          {...props}
          className={cls}
          value={value}
          iconLeft='calendar'
          type='date'
          onChange={this.handleOnChangeDatePicker}
        />
      )
    }

    const newValue = value && DateFormatter.dateToDDMMYYYY(value)

    const DateInput = (
      <InputDate
        {...props}
        className={cls}
        value={newValue}
        onFocus={this.preventFocus}
      />
    )

    if (this.props.disabled) {
      return DateInput
    }

    return (
      <Popover
        trigger={DateInput}
        className={classNames([`${cls}__popover`, className])}
        position={'full'}
        align={'left'}
      >{({ hide, callAll }) => (
          <DatePicker
            range={{ end: undefined, start: value }}
            calendarPick
            quickPick={false}
            manualPick={false}
            onSelect={callAll(this.handlePickerSelect, hide)}
            onCancel={hide}
            minYear={minYear}
            maxYear={maxYear}
            defaultValue={defaultValue}
            withoutHeader={withoutHeader}
          />
        )}</Popover>
    )
  }

  private handlePickerSelect (selectedDate: IDateRange) {
    const { onChange } = this.props
    const returnDate = selectedDate.start
      ? DateFormatter.dateInDatePickerFormat(selectedDate.start)
      : ''

    onChange && onChange(returnDate)
  }

  private handleOnChangeDatePicker (value: string) {
    const { onChange } = this.props
    if (onChange) {
      onChange(value)
    }
  }

  private preventFocus (event: React.FormEvent<HTMLElement>) {
    const target = event.target as HTMLInputElement
    target.blur && target.blur()
  }
}
